import { render, staticRenderFns } from "./ContactoForm.vue?vue&type=template&id=31033f5c&"
import script from "./ContactoForm.vue?vue&type=script&lang=js&"
export * from "./ContactoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports